import { ClassItemType } from '@/types/class.type'
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface ClassStates {
  class: {
    selectedUserRole: 'student' | 'tutor' | string
    selectedClass: ClassItemType | null
    setSelectedClass: (item: ClassItemType | null) => void
    setSelectedUserRole: (role: 'student' | 'tutor' | string) => void
    clear: () => void
  }
}

export const useClass = create<ClassStates>()(
  persist(
    (set) => ({
      class: {
        selectedUserRole: 'tutor',
        selectedClass: null,
        setSelectedClass: (item) =>
          set((state) => ({
            ...state,
            class: { ...state.class, selectedClass: item },
          })),
        setSelectedUserRole: (role) =>
          set((state) => ({
            ...state,
            class: {
              ...state.class,
              selectedUserRole: role.toLocaleLowerCase(),
            },
          })),
        clear: () =>
          set((state) => ({
            ...state,
            class: { ...state.class, selectedClass: null },
          })),
      },
    }),
    {
      name: 'classes-store',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        class: {
          selectedUserRole: state.class.selectedUserRole,
          selectedClass: state.class.selectedClass,
        },
      }),
      merge: (persistedState, currentState) => {
        const persisted = persistedState as Partial<ClassStates>
        return {
          ...currentState,
          class: {
            ...currentState.class,
            ...(persisted.class ?? {}),
          },
        }
      },
    }
  )
)

export const useClassStore = () => useClass((state) => state.class)
